import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { IGroupLink } from "../models/group/group"
import { HttpParams, HttpClient, HttpHeaders } from "@angular/common/http"
import { GroupChangeStatusInBatchRequest } from "../models/group/group-change-status-in-batch-request"
import { CustomURLEncoder } from "src/app/core/helpers/http-params-extensions"
import { HEADERS } from "./const/http-header-interception"

@Injectable()
export class GroupService {
  private get_group_url: string
  private get_group_autoComple_url: string
  private post_group_groupUpdateInBatch_url = environment.endpointClasses.url + environment.endpointClasses.routes.post_update_in_batch
  private put_change_status_in_batch_url: string

  private buildUrls(groupUrl: string) {
    this.get_group_url =
      groupUrl + environment.endpointSchoolClass.routes.get_group
    this.get_group_autoComple_url =
      groupUrl + environment.endpointSchoolClass.routes.get_group_autoComplete
    this.put_change_status_in_batch_url =
      groupUrl +
      environment.endpointSchoolClass.routes.put_change_status_in_batch
  }

  constructor(private httpClient: HttpClient) {
    this.buildUrls(environment.endpointSchoolClass.url)
  }

  getAllGroups() {
    return this.httpClient.get<any>(this.get_group_url, { headers: new HttpHeaders(HEADERS) })
  }

  getAutoCompleteGroup(value: string) {
    const params = new HttpParams({ encoder: new CustomURLEncoder() }).set(
      "term",
      value
    )
    return this.httpClient.get<any>(this.get_group_autoComple_url, { params, headers: new HttpHeaders(HEADERS) })
  }

  postFitInClass(groupLink: IGroupLink) {
    return this.httpClient.post(
      this.post_group_groupUpdateInBatch_url,
      groupLink, { headers: new HttpHeaders(HEADERS) }
    )
  }

  putChangeStatusInBatch(model: GroupChangeStatusInBatchRequest) {
    return this.httpClient.put(this.put_change_status_in_batch_url, model, { headers: new HttpHeaders(HEADERS) })
  }
}
